import React, { useLayoutEffect, useRef, useState } from "react";
import { gsap } from "gsap";
import { Link } from "react-router-dom";
import { jobs, Category } from "./jobs";
import jobBg from "../../images/bg/job-bg.png";
import diamondIcon from "../../images/icon/diamond-icon02.gif";
import locIcon from "../../images/icon/location-icon02.svg";
import "./JobSection.css";

const filters: { label: string; value: Category | "*" }[] = [
  { label: "View all", value: "*" },
  { label: "Technical", value: "technical" },
  { label: "HR & Talent", value: "hr" },
  { label: "Business", value: "business" },
  { label: "Freshers & Opportunities", value: "opportunities" },
];

const JobSection: React.FC = () => {
  const [activeFilter, setActiveFilter] = useState<Category | "*">("*");
  const gridRef = useRef<HTMLDivElement>(null);
  const visibleJobs = jobs.filter(
    (job) => activeFilter === "*" || job.category === activeFilter,
  );

  useLayoutEffect(() => {
    const grid = gridRef.current;
    if (!grid || window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    const context = gsap.context(() => {
      gsap.fromTo(
        grid.querySelectorAll(".grid-item"),
        { opacity: 0, y: 16 },
        { opacity: 1, y: 0, duration: 0.35, stagger: 0.035, ease: "power2.out" },
      );
    }, grid);
    return () => context.revert();
  }, [activeFilter]);

  return (
    <section
      id="open-positions"
      className="job_section pt-90 pb-150 bg_img"
      style={{ backgroundImage: `url(${jobBg})` }}
      aria-labelledby="open-positions-title"
    >
      <div className="container">
        <div className="sec-title sec-title-center fea-sec-title text-center mb-40">
          <span className="sub-title">Open Positions</span>
          <h2 id="open-positions-title" className="title">
            Be part of{" "}
            <span><img src={diamondIcon} alt="" /></span>{" "}
            the team
          </h2>
        </div>

        <div className="text-center">
          <div className="career-menu ul_li" role="group" aria-label="Filter opportunities"
            style={{ flexWrap: "wrap", justifyContent: "center" }}>
            {filters.map((filter) => (
              <button
                key={filter.value}
                type="button"
                className={activeFilter === filter.value ? "active" : ""}
                aria-pressed={activeFilter === filter.value}
                aria-controls="career-job-grid"
                onClick={() => setActiveFilter(filter.value)}
              >
                {filter.label}
              </button>
            ))}
          </div>
          <p role="status" className="mt-20">
            {visibleJobs.length} {visibleJobs.length === 1 ? "opportunity" : "opportunities"}
          </p>
        </div>

        <div
          id="career-job-grid"
          ref={gridRef}
          className="career-nav-wrapper grid mt-40"
        >
          {visibleJobs.map((job) => (
            <div
              key={job.slug}
              className="xb-career-item grid-item xb-border"
              data-category={job.category}
            >
              <div className="xb-item--content">
                <h3 className="xb-item--title">
                  <Link to={`/career-details/${job.slug}`}>
                    {job.title}
                  </Link>
                </h3>
                <ul className="xb-item--holder ul_li list-unstyled"
                  style={{ flexWrap: "wrap", rowGap: "12px" }}>
                  <li><img src={locIcon} alt="" /> {job.location}</li>
                  <li><strong>Qualification:</strong> {job.qualification}</li>
                </ul>
              </div>
              <div className="team-btn">
                <Link className="career-view-job" to={`/career-details/${job.slug}`}
                  aria-label={`View details and apply: ${job.title}`}>
                  <span className="career-view-job__text">View Job</span>
                  <span className="career-view-job__arrow" aria-hidden="true">
                    <span className="career-view-job__icon">
                      <svg
                        width="28"
                        height="28"
                        viewBox="0 0 28 28"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <rect
                          x="5.06592"
                          y="19.9785"
                          width="20.5712"
                          height="2.61221"
                          transform="rotate(-40.2798 5.06592 19.9785)"
                          fill="white"
                        />
                        <rect
                          x="7.97095"
                          y="7.24463"
                          width="2.61221"
                          height="2.61221"
                          transform="rotate(-40.2798 7.97095 7.24463)"
                          fill="white"
                        />
                        <rect
                          x="11.6523"
                          y="7.54834"
                          width="2.61221"
                          height="2.61221"
                          transform="rotate(-40.2798 11.6523 7.54834)"
                          fill="white"
                        />
                        <rect
                          x="15.334"
                          y="7.85205"
                          width="2.61221"
                          height="2.61221"
                          transform="rotate(-40.2798 15.334 7.85205)"
                          fill="white"
                        />
                        <rect
                          x="18.7119"
                          y="11.8374"
                          width="2.61221"
                          height="2.61221"
                          transform="rotate(-40.2798 18.7119 11.8374)"
                          fill="white"
                        />
                        <rect
                          x="18.4084"
                          y="15.52"
                          width="2.61221"
                          height="2.61221"
                          transform="rotate(-40.2798 18.4084 15.52)"
                          fill="white"
                        />
                        <rect
                          x="18.104"
                          y="19.2012"
                          width="2.61221"
                          height="2.61221"
                          transform="rotate(-40.2798 18.104 19.2012)"
                          fill="white"
                        />
                      </svg>
<svg
                        width="28"
                        height="28"
                        viewBox="0 0 28 28"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <rect
                          x="5.06592"
                          y="19.9785"
                          width="20.5712"
                          height="2.61221"
                          transform="rotate(-40.2798 5.06592 19.9785)"
                          fill="white"
                        />
                        <rect
                          x="7.97095"
                          y="7.24463"
                          width="2.61221"
                          height="2.61221"
                          transform="rotate(-40.2798 7.97095 7.24463)"
                          fill="white"
                        />
                        <rect
                          x="11.6523"
                          y="7.54834"
                          width="2.61221"
                          height="2.61221"
                          transform="rotate(-40.2798 11.6523 7.54834)"
                          fill="white"
                        />
                        <rect
                          x="15.334"
                          y="7.85205"
                          width="2.61221"
                          height="2.61221"
                          transform="rotate(-40.2798 15.334 7.85205)"
                          fill="white"
                        />
                        <rect
                          x="18.7119"
                          y="11.8374"
                          width="2.61221"
                          height="2.61221"
                          transform="rotate(-40.2798 18.7119 11.8374)"
                          fill="white"
                        />
                        <rect
                          x="18.4084"
                          y="15.52"
                          width="2.61221"
                          height="2.61221"
                          transform="rotate(-40.2798 18.4084 15.52)"
                          fill="white"
                        />
                        <rect
                          x="18.104"
                          y="19.2012"
                          width="2.61221"
                          height="2.61221"
                          transform="rotate(-40.2798 18.104 19.2012)"
                          fill="white"
                        />
                      </svg>
                    </span>
                  </span>
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default JobSection;
